export enum VesselComparisonMode {
  Chart = "chart",
  Table = "table",
}

export type Metric = {
  name: string;
  title: string;
}

export type TrendEvent = {
  id: number;
  name: string;
  source: string;
  timestamp: string;
  type: "TrendEvent";
  vesselId: number;
}